export interface SeparatorProps {
  label?: string;
  className?: string;
}

/**
 * Separator component - horizontal divider with optional label
 * Based on common shadcn/ui pattern
 */
export function Separator({ label, className = '' }: SeparatorProps) {
  if (label) {
    // Labeled separator (used for section divisions)
    return (
      <div className={`relative py-4 ${className}`}>
        <div className="absolute inset-0 flex items-center">
          <div className="w-full border-t border-border"></div>
        </div>
        <div className="relative flex justify-center">
          <span className="bg-background px-3 text-xs font-medium text-muted-foreground uppercase tracking-wide">
            {label}
          </span>
        </div>
      </div>
    );
  }

  // Simple separator (just a line)
  return <div className={`border-t border-border ${className}`}></div>;
}
